import IcoMoon, { IconProps } from "react-icomoon";
import selection from "./selection.json";

export default function Icon(props: IconProps) {
  return <IcoMoon data-testid={props.icon} size={props.size ?? 24} iconSet={selection} {...props} />;
}
